let JSEncrypt = null;

if (process.browser) {
  JSEncrypt = require('jsencrypt').default;
}

const encryptPublicKeyV1 =
  '-----BEGIN PUBLIC KEY-----\
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDmRjZFlLX9akll+2dCdtN5ehDx\
PvmWes3kchShI1FafeorF+LWm5oK2YJFTpzA9WO2Xod1Q1FUrt82bjfYRHDfoerJ\
6rjMtjgXnDAYsk6nbhefibbQzYzxNA62yc6TbpUvRi+SosLfGQifqwtu/6OBMoka\
gLvbujKFpAfb9cfGewIDAQAB\
-----END PUBLIC KEY-----';

const encryptPublicKeyV2 =
  '-----BEGIN PUBLIC KEY-----\
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDP2l/hjQNbXH+ZEzGjgv312FYb\
QpycXKo54HEs1ROk079Ez7fY6jdrofen82YcUo8TvFA1gN4y0fLNNBsh+VuGW5V5\
ZwaD4fHVzWJ2D1LDjoZ+UCrvLPbUEToCmWCQwPnOqf/IKxszmIbPAutSvJu5sIzM\
OAvPZtxeY3ZaSlaWdwIDAQAB\
-----END PUBLIC KEY-----';

class Encrypt {
  constructor(props) {
    if (typeof window !== 'undefined' && JSEncrypt !== null) {
      this.encrypt = new JSEncrypt();
      this.encrypt.setPublicKey(props.publicKey);
    }
  }
  encryptPassword(password) {
    if (typeof window !== 'undefined') {
      return this.encrypt.encrypt(password);
    }
  }
}

export default {
  v1: new Encrypt({ publicKey: encryptPublicKeyV1 }),
  v2: new Encrypt({ publicKey: encryptPublicKeyV2 }),
};
